import { useEffect, useState } from "react";

interface UseWindowResizeParams {
    onWindowResize?: (innerWidth: number) => void;
}

interface UseWindowResizeResult {
    innerWidth: number;
}

const useWindowResize: (
    params: UseWindowResizeParams
) => UseWindowResizeResult = (params) => {
    const { onWindowResize } = params;
    const [innerWidth, setInnerWidth] = useState<number>(window?.innerWidth);

    const onResizeHandler = () => {
        setInnerWidth(window?.innerWidth);
    };

    useEffect(() => {
        window.addEventListener("resize", onResizeHandler);

        return () => {
            window.removeEventListener("resize", onResizeHandler);
        };
    }, []);

    useEffect(() => {
        if (!!onWindowResize) {
            onWindowResize(innerWidth);
        }
    }, [innerWidth]);

    return {
        innerWidth,
    };
};

export default useWindowResize;
